<template>
  <div>
    <div v-if="uniformOrdersData._id" class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="uniformOrdersData ? `${uniformOrdersData.name}` : 'Đơn đăng ký đồng phục'"
          :link="[{ text: 'Học sinh', href: '../uniform-orders-register' }, { text: 'Đơn đăng ký đồng phục' }]"
        />
      </div>
    </div>
    <!-- <StudentProfile v-if="student.id" :student="student" /> -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
// import StudentProfile from './components/StudentProfile'

export default {
  components: {
    // StudentProfile,
    Breadcrumbs,
  },
  computed: {
    ...mapGetters('UniformOrdersRegister', ['uniformOrdersData']),
  },
  async created() {
    console.log(this.$route.params.id)
    await this.fetchUniformOrder(this.$route.params.id)
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['fetchUniformOrder']),
  },
}
</script>
